import React from "react";


export default function Title() {
  return null;
}
